import React, { useState } from 'react'
import Button from '@dustin-web/microsite-components/src/button'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { CategoryNavigationTreeItem } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import SearchNavigationItem from './search-navigation-item'

type Props = {
  navigationItems: any[]
  selectedCategoryPath: string
  buildPublicUrl: (navItem: CategoryNavigationTreeItem) => string
  onItemClick?: (selection: string) => void
}

const SearchNavigationItemList = ({
  navigationItems,
  selectedCategoryPath,
  buildPublicUrl,
  onItemClick,
}: Props) => {
  const [fullyExpanded, setFullyExpanded] = useState(false)
  const { translate } = useTranslations()

  const renderChildren = (navItem: any, selectedCategoryPathSlug: string) => {
    const isSelected = selectedCategoryPathSlug.includes(navItem.categoryPathSlug)
    if (isSelected && navItem.children && navItem.children.length > 0) {
      return (
        <SearchNavigationItemList
          navigationItems={navItem.children}
          selectedCategoryPath={selectedCategoryPathSlug}
          buildPublicUrl={buildPublicUrl}
          onItemClick={onItemClick}
        />
      )
    }
  }

  const renderItem = (navItem: CategoryNavigationTreeItem, selectedCategoryPathSlug: string) => {
    return (
      <SearchNavigationItem
        onItemClick={onItemClick}
        navItem={navItem}
        selectedCategoryPath={selectedCategoryPathSlug}
        buildPublicUrl={buildPublicUrl}
      />
    )
  }

  return (
    <>
      <ul className="c-filter-categories ul-stripped">
        {navigationItems.map(
          (navItem, i) =>
            (i < 8 || fullyExpanded || navigationItems.length <= 9) && (
              <li className="c-filter-categories__category" key={navItem.categoryPathSlug + i}>
                {renderItem(navItem, selectedCategoryPath)}
                {renderChildren(navItem, selectedCategoryPath)}
              </li>
            )
        )}
      </ul>

      {navigationItems.length > 9 && (
        <div className="u-text-center">
          <Button
            defaultBtn
            id="siblings-collapsible-facets"
            className="button-stripped u-mb-0"
            icon={fullyExpanded ? 'arrow-up-small' : 'arrow-down-small'}
            text={<span>{translate(fullyExpanded ? 'CollapseFacets' : 'ExpandFacets')}</span>}
            onClick={e => {
              e.preventDefault()
              setFullyExpanded(() => !fullyExpanded)
            }}
          />
        </div>
      )}
    </>
  )
}

export default SearchNavigationItemList
